/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-explicit-any */

import type { FormQuestion, FormAnyQuestion } from './types'

type DefaultValueType = any

interface IgetQuestionsDefaultSettings {
  deep?: boolean
}

/**
 * @function getQuestionDefault
 * @desc Returns default value for a given question or object of defaultValues if question contains nested fields
 * @param [question] - Question
 * @param [opt.deep=false] - Whether to get default value from nested fields if question default value is missing
 */
export function getQuestionDefault (question: FormAnyQuestion, { deep = false }: IgetQuestionsDefaultSettings = {}): DefaultValueType {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
  const defaultsConfigValue: DefaultValueType = question.config?.default?.value
  if (!isMissingValue(defaultsConfigValue)) return defaultsConfigValue
  if (!deep) return undefined
  const nestedFields = (question.fields || question.config?.fields) as Record<string, FormQuestion>
  if (!nestedFields) return undefined
  const nestedDefaultValuesObject = Object.values(nestedFields).reduce((acc, nestedQuestion) => {
    const nestedQuestionDefaultValue = getQuestionDefault(nestedQuestion)
    if (!isMissingValue(nestedQuestionDefaultValue)) {
      acc[nestedQuestion.dataKey] = nestedQuestionDefaultValue
    }
    return acc
  }, {} as Record<string, DefaultValueType>)
  if (Object.keys(nestedDefaultValuesObject).length) return nestedDefaultValuesObject
  return undefined
}

export function isMissingValue (value: any): boolean {
  const MISSING_VALUES = [ null, undefined, '' ]
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  return MISSING_VALUES.includes(value)
}
